import React from 'react';
import '@elastic/eui/dist/eui_theme_light.css';
import { EuiText, EuiFlexGroup, EuiFlexItem, EuiSpacer, EuiPageTemplate, EuiPageHeader, EuiImage } from '@elastic/eui';
import styled from 'styled-components';
import { Header } from '../components/header';
import { Footer } from '../components/footer';
import patent1image from '../../documents/patent1image.png'

const StyledText = styled.div`
  ul.skills-list {
    display: grid;
    grid-gap: 0 10px;
    padding: 0;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      font-family: var(--font-mono);
      font-size: var(--fz-xs);

      &:before {
        content: '• ';
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 12px;
      }
    }
  }
`;
class Patent1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: [],
            isModalVisible: false,
            files: {},
            uploadDisabled: true,
            selection: [],
            columns: [],
            AlertText: "",
            AlertType: "error",
            patent1objective: "To build a fusion model for robust prediction of mechanical properties of concrete using Industry 4.0 C protocols",
            skills: ["Deep learning", "Data Analysis", "Research Machine", "Learning Innovation", "Rational     Analytics", "Multi-Disciplinary", "CNN", "AI", "Computer vision"],
            patent1Key: ['	Industry 4.0 C (C- Civil, Concrete, Construction)','	Concrete strength prediction using mix proportion',
            '	Reflects real time changes in mix proportion ','	Comparison with empirical and other AI methods','	Developed 6+ Hybrid machine learning and deep learning models',
            'Reliable and rational input parameters','	Incorporates mathematical stability, dimensional homogeneity& reduction ','	Modified feature scaling attribute','	Web and mobile application is unique, user-friendly, user-defined and rapid',
          '	Future Scope - Integration with Maturity meter','	Leaded the group to productive research','	Optimizes  5M’s (Man, money, material, minutes and machineries)'],
            patent1Value: ['Innovation', 'Concept development ', 'Inter-disciplinary engineering']
        }
    }

    render() {

        return (
            <>
                <EuiPageTemplate>
                    <EuiPageHeader><Header /></EuiPageHeader>
                        <EuiSpacer />
                        <EuiText><h2><font face='Segoe UI'>Universal Hybrid Model to Predict Mix Based Compressive Strength and
                        Allied Mechanical Properties of Concrete, Indian Patent, No-202121022677</font></h2></EuiText>
                        <EuiSpacer size='m' />
                        <EuiText><h5><font face='Segoe UI'>Mentor :- Dr. Hemant Dhonde 
                        &emsp; &emsp; &emsp; &emsp; &emsp;
                        &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp;
                        &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp; &emsp;
                        &emsp; &emsp; &emsp; August 2020 – Present</font></h5></EuiText>
                        <EuiSpacer size='m' />
                <EuiFlexGroup gutterSize='xl' justifyContent='spaceBetween'>
                <EuiFlexItem grow={false}>
                        <EuiText>
                        <b>Research Objectives</b><br/>
                        {this.state.patent1objective}<EuiSpacer/>
                        <b>Key Highlights</b> 
                        <StyledText><ul className="skills-list">
                        {this.state.patent1Key && this.state.patent1Key.map((p, i) => <li key={i}>{p}</li>)}
                        </ul></StyledText>
                        <b>Value Additions</b>
                        <StyledText><ul className="skills-list">
                        {this.state.patent1Value && this.state.patent1Value.map((p, i) => <li key={i}>{p}</li>)}
                        </ul></StyledText></EuiText>
                </EuiFlexItem><EuiFlexItem grow={false}><EuiText textAlign='center'><EuiImage size='l' src={patent1image} /><EuiSpacer size = 's'/>
                Mobile application is unique, user-friendly, user-defined & rapid</EuiText></EuiFlexItem>
                </EuiFlexGroup>
            <Footer /></EuiPageTemplate>
            </>
        )
    }
};

export { Patent1 }